import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAllProperty } from "reduxStore/action/propertyActions";
import { apiCall } from "utils/httpClient";
import apiEndPoints from "utils/apiEndPoints";

// Modal Component
const AllocatePropertyModal = ({ show, cp_id, handleClose, onPropertiesSelected }) => {
  const dispatch = useDispatch();
  const [selectedProperties, setSelectedProperties] = useState([]); // Selected properties (checked)
  const [allPropertyList, setAllPropertyList] = useState([]); // All available properties
  const [allProperty, setAllProperty] = useState([]); // Properties that are checked

  const AllpropertySelector = useSelector((state) => state.propertyData);

  // Fetch all properties on component mount or on cp_id change
  useEffect(() => {
    dispatch(getAllProperty({}));
  }, [dispatch]);

  useEffect(() => {
    if (AllpropertySelector?.response && AllpropertySelector?.response?.status === 200) {
      const activeProperties = AllpropertySelector?.response?.data?.filter(property => property.status === true);
      setAllPropertyList(activeProperties); // Store all properties
    } else {
      setAllPropertyList([]);
    }
  }, [AllpropertySelector]);


  // Fetch properties related to cp_id
  useEffect(() => {
    const fetchProperties = async () => {
      if (cp_id) {
        const params = { cp_id };
        try {
          const res = await apiCall('post', apiEndPoints.GET_CP_PROPERTY_FOR_SM, params);
          const response = res?.data;

          if (response?.status === 200) {
            if (response?.data?.length > 0) {
              const list = allPropertyList?.filter((o1) =>
                response?.data?.some((o2) => o1?._id === o2?.property_id)
              );
              setAllProperty(list); // Store filtered properties based on cp_id
            } else {
              setAllProperty([]); // No properties found
            }
          } else {
            setAllProperty([]); // Error response, reset the property list
          }
        } catch (error) {
          console.error('Error fetching properties:', error);
          setAllProperty([]); // In case of an error, reset the property list
        }
      }
    };

    fetchProperties();
  }, [cp_id, allPropertyList]);

  // Handle checkbox change
  const handleCheckboxChange = (property) => {
    setSelectedProperties((prevSelected) => {
      // If the property is already selected, remove it; otherwise, add it
      if (prevSelected.some((item) => item._id === property._id)) {
        return prevSelected.filter((item) => item._id !== property._id); // Unselect property
      } else {
        return [...prevSelected, property]; // Select property
      }
    });
  };

  // Automatically check properties in allProperty if they exist in allPropertyList
  useEffect(() => {
    // Sync selected properties with allProperty
    if (allPropertyList.length > 0) {
      const selected = allPropertyList.filter((property) =>
        allProperty.some((selectedProp) => selectedProp._id === property._id)
      );
      setSelectedProperties(selected);
    }
  }, [allPropertyList, allProperty]);

  // Handle "Save Changes" click, pass selected properties to parent if cp_id is not available
  const handleSaveChanges = () => {
    if (!cp_id && onPropertiesSelected) {
      onPropertiesSelected(selectedProperties); // Send selected properties to parent
    }
    handleClose(); // Close the modal after saving
  };

  // Return null if modal is not shown
  if (!show) return null;

  return (
    <>
      {/* Backdrop with blur effect */}
      <div
        className="modal-backdrop"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
          backdropFilter: 'blur(5px)', // Blur effect on the background
          zIndex: 1040,
        }}
      ></div>

      {/* Modal Dialog */}
      <div className="modal show" style={{ display: 'block', zIndex: 1050 }} tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content" style={{ height: '80vh' }}>
            <div className="modal-header">
              <h5 className="modal-title">Allocate Property</h5>
              <button type="button" className="close" onClick={handleClose}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {/* Display selected properties in a box */}
              <div
                style={{
                  border: '1px solid #ccc',
                  padding: '10px',
                  marginBottom: '20px',
                  minHeight: '60px',
                  backgroundColor: '#f9f9f9',
                }}
              >
                <strong>Selected Properties:</strong>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap', // Allow wrapping when items exceed container width
                    gap: '10px', // Space between each selected property
                  }}
                >
                  {selectedProperties.length === 0
                    ? 'No properties selected'
                    : selectedProperties.map((property, index) => (
                        <div
                          key={index}
                          style={{
                            border: '1px solid #007bff', // Border for each selected property
                            padding: '5px 10px',
                            backgroundColor: '#e7f1ff', // Light background color
                            borderRadius: '4px', // Rounded corners for each selected property
                          }}
                        >
                          {property?.property_title}
                        </div>
                      ))}
                </div>
              </div>

              {/* List of properties with checkboxes */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {allPropertyList?.map((property) => (
                  <div
                    key={property?._id}
                    style={{
                      flex: '0 0 48%', // Set each item to take up 48% of the container width
                      boxSizing: 'border-box', // Ensure padding/border doesn't affect the width calculation
                    }}
                  >
                    <label style={{ display: 'flex', alignItems: 'center' }}>
                      <input
                        type="checkbox"
                        checked={selectedProperties.some((p) => p._id === property._id)} // Check if the property is selected
                        onChange={() => handleCheckboxChange(property)}
                      />
                      <span style={{ marginLeft: '10px' }}>{property?.property_title}</span>
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleClose}>
                Close
              </button>
              <button type="button" className="btn btn-primary" onClick={handleSaveChanges}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllocatePropertyModal;

